export const URL = `https://forkify-api.herokuapp.com/api/v2/recipes`;
export const RES_PER_PAGE = 10;
export const TIME_OUT_SEC = 10;
